import React from "react"
import styles from "./CopyInput.module.scss"
import { Button } from "react-bootstrap"
import { faCopy, faSync, faTrash } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { formTranslation } from "../../locales/form"
import { useTranslation } from "react-i18next"
import copy from "copy-to-clipboard"
import { ClassProps } from "../../utility/common/props"
import cn from "classnames"
import LoadingButton from "../LoadingButton/LoadingButton"
import ActionInput from "../ActionInput/ActionInput"
import VerticalInputGroup from "../FormHelpers/VerticalInputGroup/VerticalInputGroup"
import { useTooltipWithTimeout } from "../../hooks/useTooltipWithTimeout"

export interface CopyInputProps extends ClassProps {
    id: string
    label?: string
    value?: string
    as?: React.ElementType
    blocked?: boolean
    loading?: boolean
    onUpdate?: () => void
    deleteLoading?: boolean
    onDelete?: () => void
    readOnly?: boolean
    placeholder?: string
    testId?: string
}

const CopyInput: React.FC<CopyInputProps> = props => {
    const {
        id,
        label,
        value = "",
        className,
        as,
        blocked,
        loading,
        onUpdate,
        onDelete,
        deleteLoading,
        readOnly = true,
        placeholder,
        testId
    } = props

    const { t } = useTranslation()
    const [show, tooltipLabel, setTooltipLabel] = useTooltipWithTimeout()

    const handleClick = () => {
        copy(value)
        setTooltipLabel(t(formTranslation.copied))
    }

    const actions = (
        <>
            <Button
                as="div"
                className={cn(!readOnly ? styles.copyInput__control : undefined, blocked && "blocked")}
                variant="light"
                onClick={handleClick}
            >
                <FontAwesomeIcon icon={faCopy} />
            </Button>
            {onUpdate && (
                <LoadingButton
                    as="div"
                    className={cn(!readOnly ? styles.copyInput__control : undefined)}
                    onClick={onUpdate}
                    variant="light"
                    loading={loading}
                >
                    <FontAwesomeIcon icon={faSync} />
                </LoadingButton>
            )}
            {onDelete && (
                <LoadingButton
                    as="div"
                    className={cn(!readOnly ? styles.copyInput__control : undefined)}
                    onClick={onDelete}
                    variant="light"
                    loading={deleteLoading}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </LoadingButton>
            )}
        </>
    )

    return (
        <VerticalInputGroup label={label} controlId={id}>
            <ActionInput
                id={id}
                actions={actions}
                tooltipLabel={tooltipLabel}
                isTooltipShow={show}
                readOnly={readOnly}
                value={value}
                as={as}
                className={className}
                testId={testId}
                placeholder={placeholder}
                onChange={() => void 0}
            />
        </VerticalInputGroup>
    )
}

export default CopyInput
